"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectNextSequentialTrial = selectNextSequentialTrial;
const taskStore_1 = require("../../../taskStore");
// selects the next trial in a block of sequential trials
function selectNextSequentialTrial(nextTrials) {
    if (nextTrials.length === 0) {
        // increment the current story for ToM if we've reached the end of the block
        if ((0, taskStore_1.taskStore)().task === 'theory-of-mind') {
            (0, taskStore_1.taskStore)('currentStoryGroup', (0, taskStore_1.taskStore)().currentStoryGroup + 1);
        }
        return;
    }
    const allSequentialTrials = (0, taskStore_1.taskStore)().sequentialTrials;
    const nextStim = nextTrials[0];
    (0, taskStore_1.taskStore)('nextStimulus', nextStim);
    const newSequentialTrials = allSequentialTrials.filter((trial) => trial.itemId !== nextStim.itemId);
    (0, taskStore_1.taskStore)('sequentialTrials', newSequentialTrials);
}
